/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Storytelling (C) Copyright IBM Corp. 2018, 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([
	'./PlaceholderView',
	'text!./TextPlaceholder.html',
	'../../util/TextFitUtil',
	'../../../app/nls/StringResources'
], function(BaseClass, Template, TextFitUtil, stringResources) {
	var TextPlaceholderView = null;

	TextPlaceholderView = BaseClass.extend({
		templateString: Template,

		init: function(options = {}) {
			TextPlaceholderView.inherited('init', this, arguments);
			this.text = options.text || stringResources.get('textPlaceHolder');
		},

		render: function() {
			let sHtml = this.dotTemplate({
				placeholderText: this.text
			});
			this.$el.append(sHtml);
		},

		show: function() {
			TextPlaceholderView.inherited('show', this, arguments);
			this.fillText();
		},

		fillText: function() {
			const node = this.el.querySelector('.placeholder.text');

			if (!node || node.style.display === 'none') {
				return;
			}

			node.classList.add('textFillNoScroll');

			const options = {
				maxFontSize: Math.ceil(node.clientHeight),
				minFontSize: 1,
				multiLine: false,
				detectMultiLine: false
			};

			TextFitUtil.fillText(node, options);
		}
	});

	return TextPlaceholderView;
});
